module.exports = __webpack_public_path__ + "img/img_aiplan_01.d021d4b9.png";